<p-chart type="bar" [data]="data"></p-chart>
